import type { ComputeCoordinateExtents } from "./types";

export const computeCoordinateExtents: ComputeCoordinateExtents = (points) => {
  if (points.length === 0) {
    return { minX: 0, minY: 0, maxX: 0, maxY: 0 };
  }

  let minX = points[0].x;
  let minY = points[0].y;
  let maxX = points[0].x;
  let maxY = points[0].y;

  for (let i = 1; i < points.length; i++) {
    const point = points[i];
    if (point.x < minX) minX = point.x;
    else if (point.x > maxX) maxX = point.x;
    if (point.y < minY) minY = point.y;
    else if (point.y > maxY) maxY = point.y;
  }

  return { minX, minY, maxX, maxY };
};
